/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Queue_Sos_To_AllocateInputs */

const en_queue_sos_to_allocate = /** @type {(inputs: Queue_Sos_To_AllocateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sales orders to allocate`)
};

/**
* | output |
* | --- |
* | "Sales orders to allocate" |
*
* @param {Queue_Sos_To_AllocateInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const queue_sos_to_allocate = /** @type {((inputs?: Queue_Sos_To_AllocateInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Queue_Sos_To_AllocateInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_queue_sos_to_allocate(inputs)
});